/** Find and Return path to project folder. If folder did not found new path will be returned */
export const getProjectFolder = async ({ title, _id, created }) => {};

export const deleteProjectFolder = async (projectId) => {};
